import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ComparativeAnalysisPopoverContentService {
  constructor(private http: HttpClient) {}

  getComparativeAnalysisPopoverData(ticker: string): Observable<any> {
    return this.http.get(
      `${window.apiUrl}/api/get_comparative_analysis_details?ticker=${ticker}`,
    );
  }
}
